import SignupForm from './connected';

export default SignupForm;